import IMask from 'imask/dist/imask.min'

const moduleName = 'forms';

export function forms() {
    // document.querySelectorAll('input.js-dep-placeholder').forEach((input) => {
    //     input.addEventListener('change', function (){
    //         const placeholder = this.dataset.depPlaceholder;
    //         const depInput = document.querySelector(`#${this.dataset.depId}`);
    //         if(this.checked){
    //             depInput.placeholder = placeholder;
    //         }
    //     });
    // });
    document.querySelectorAll('input[type="checkbox"]').forEach((input)=>{
        const checkInit = (input) => {
            const wrap = input.closest('.check-wrap');
            if(wrap){
                if(input.checked){
                    wrap.classList.add('check-wrap--checked');
                }else{
                    wrap.classList.remove('check-wrap--checked');
                }
            }
        };
        checkInit(input);
        input.addEventListener('change', function (){
            checkInit(input);
        });
    });

    document.querySelectorAll('.js-clear-input').forEach((btn) => {
        btn.addEventListener('click', function (){
            const input = this.parentNode.querySelector('input');
            input.value = '';
        });
    });
    document.querySelectorAll('.js-clear-phone').forEach((btn) => {
        btn.addEventListener('click', function (){
            const input = this.parentNode.querySelector('input');
            input.value = '+7 (___) ___ __ __';

            // input.value = '';
            // const mask = IMask(input, {
            //     mask: '+7 (000) 000 00 00',
            //     lazy: false
            // });
            // mask.value = '';

        });
    });
    document.querySelectorAll('.js-timer-btn').forEach((btn) => {
        const timer = btn.querySelector('.btn-timer');
        const limit = +btn.dataset.limit;
        let current = 1;
        const timing = setInterval(function () {
            if(++current > limit) {
                clearInterval(timing);
                btn.disabled = false;
                timer.remove();
            }
            timer.textContent = current;
        }, 1000);
    });
    document.querySelectorAll('.js-switch-checkbox').forEach((input) => {
        const label = input.parentNode.querySelector('label');
        const span1 = label.querySelector('span:first-child');
        const span2 = label.querySelector('span:nth-child(2)');
        const span3 = label.querySelector('span:last-child');
        const wrap = input.closest('.check-wrap');
        function checkedSwitchInput(input) {
            if(input.checked) {
                span1.style.width = `${span3.offsetWidth}px`;
                span1.style.transform = `translateX(${span2.offsetWidth - 3}px)`;
                wrap.classList.add('check-wrap--checked');
            }else{
                span1.style.width = `${span2.clientWidth}px`;
                span1.style.transform = `translateX(0)`;
                wrap.classList.remove('check-wrap--checked');
            }
        }
        checkedSwitchInput(input);
        input.addEventListener('change', function (){
            checkedSwitchInput(input);
        });
    });

    const updateCLXCount = function (items){
        document.querySelectorAll('.js-clx-item').forEach((item) => {
            const counter = item.querySelector('.js-clx-count');
            let count = 0;
            const setCounter = (count,counter) => {
                if (counter) counter.textContent = count;
                if(!count && counter){
                    counter.classList.remove('_visible');
                }else{
                    counter.classList.add('_visible');
                }
            }
            item.querySelectorAll('.js-clx-catalog-item').forEach((item) => {
                if(item.classList.contains('_in-cart')) {
                    count++;
                    setCounter(count,counter);
                }
            });
        });
    }

    // document.querySelectorAll('.js-clx-item').forEach((item) => {
    //     const counter = item.querySelector('.js-clx-count');
    //     let count = 0;
    //     const setCounter = (count,counter) => {
    //         if (counter) counter.textContent = count;
    //         if(!count && counter){
    //             counter.classList.remove('_visible');
    //         }else{
    //             counter.classList.add('_visible');
    //         }
    //     }
    //     item.querySelectorAll('.js-clx-checkbox').forEach((input) => {
    //         if(input.checked) {
    //             count++;
    //             setCounter(count,counter);
    //         }
    //         input.addEventListener('change', function (){
    //             if(input.checked){
    //                 count++;
    //             }else{
    //                 count--;
    //             }
    //             setCounter(count,counter);
    //         });
    //     });
    //     item.querySelectorAll('.js-clx-catalog-item').forEach((item) => {
    //         if(item.classList.contains('_in-cart')) {
    //             count++;
    //             setCounter(count,counter);
    //         }
    //         input.addEventListener('change', function (){
    //             if(input.checked){
    //                 count++;
    //             }else{
    //                 count--;
    //             }
    //             setCounter(count,counter);
    //         });
    //     });
    //
    // });

    document.querySelectorAll('.js-data-popup-open').forEach((el) => {
        el.addEventListener('click', function (){
            if(el.parentNode.querySelector('.js-data-popup'))
                el.parentNode.querySelector('.js-data-popup').classList.add('_visible')
            else
                el.closest('.has-popup').querySelector('.js-data-popup').classList.add('_visible');
            const clx = el.closest('.clx');
            //const wrap = el.closest('.has-popup');
            if(clx) {
                clx.classList.add('has-open-popup');
            }
            if(el.closest('.data-popup._visible')) {
                el.closest('.data-popup._visible').classList.add('has-open-sub-popup');
            }
        });
    });

    const setRemoteData = (wrap) => {
        const remotes = wrap.querySelectorAll('.remote-data');
        if(remotes){
            remotes.forEach((remote) => {
                const input = wrap.querySelector(`#${remote.dataset.sourceId}`);
                if(input && input.value){
                    remote.textContent = input.value;
                }
            });
        }
    }

    document.querySelectorAll('.js-data-popup-close').forEach((btn) => {
        btn.addEventListener('click', function (e){
            btn.closest('.js-data-popup').classList.remove('_visible');
            const clx = btn.closest('.clx');
            if(clx){
                const items = clx.querySelectorAll('.js-clx-item');
                if(items){
                    updateCLXCount(items);
                }
                if(!clx.querySelector('.data-popup._visible')){
                    clx.classList.remove('has-open-popup');
                }else {
                    if(clx.querySelector('.data-popup._visible')) {
                        clx.querySelector('.data-popup._visible').classList.remove('has-open-sub-popup');
                    }
                }
            }
            const wrap = btn.closest('.has-popup');
            if(wrap) {
                setRemoteData(wrap);
            }
            e.stopPropagation();
        });
    });

    document.querySelectorAll('.js-set-time').forEach((btn) => {
        btn.addEventListener('click', function (){
            const timeControl = btn.closest('.js-time-control');
            const timeData = timeControl.querySelector('.js-time-data');
            const inputFrom = timeControl.querySelector('.js-from-input')
            const inputUntil = timeControl.querySelector('.js-until-input')
            const fromHours = inputFrom.value.substr(0, 2);
            const fromMinutes = inputFrom.value.substr(5, 2);
            const untilHours = inputUntil.value.substr(0, 2);
            const untilMinutes = inputUntil.value.substr(5, 2);
            if(fromHours && fromHours !== '__'){
                timeData.querySelector('.js-time-from-hours').textContent = fromHours;
            }
            if(fromMinutes && fromMinutes !== '__'){
                timeData.querySelector('.js-time-from-minutes').textContent = fromMinutes;
            }
            if(untilHours && untilHours !== '__'){
                timeData.querySelector('.js-time-until-hours').textContent = untilHours;
            }
            if(untilMinutes && untilMinutes !== '__'){
                timeData.querySelector('.js-time-until-minutes').textContent = untilMinutes;
            }
        });
    });

    document.querySelectorAll('.js-data-input').forEach((input) => {
        input.addEventListener('click', function (){
            input.parentNode.querySelector('.js-data-popup').classList.add('_visible');
        });
    });
    document.querySelectorAll('.js-return-data').forEach((btn) => {
       btn.addEventListener('click', function (){
           const sourceInput = btn.closest('.js-data-popup').querySelector('.js-source-input');
           const dataInput = document.querySelector(`#${sourceInput.dataset.input}`);
           dataInput.value = sourceInput.value;
           btn.closest('.js-data-popup').classList.remove('_visible');
       });
    });

    document.querySelectorAll('.js-open-panel').forEach((btn) => {
        btn.addEventListener('click', function (){
            const panel = document.querySelector(`#${btn.dataset.panelId}`);
            if(panel){
                panel.classList.add('_visible');
                document.body.classList.add('_overlay');
            }

        });
    });
    document.querySelectorAll('.js-close-panel').forEach((btn) => {
        btn.addEventListener('click', function (){
            btn.closest('.js-panel').classList.remove('_visible');
            document.body.classList.remove('_overlay');
        });
    });
}
